import AppShell from "@/components/layouts/AppShell";

/**
 * MatchesShell — layout persistente do módulo "Matches"
 * (/matches, /who-liked-you).
 *
 * A BottomNav é montada uma única vez fora do <Outlet />: nunca some durante a
 * rolagem ou a navegação interna, e o item "Matches" permanece destacado.
 * As páginas já aplicam `pb-24`, então o shell reserva apenas a safe-area.
 */
export default function MatchesShell() {
  return <AppShell reserveBottomSpace={false} />;
}
